module.exports = __webpack_public_path__ + "img/cms-logo-drupal.6a790672.png";